export const api = {
  dev: false,
  // dev: true,
  devApiEndPoint: "https://localhost:8443/api/",
  apiEndPoint: "/api/"
};
